module.exports = __webpack_public_path__ + "static/img/2.aec9a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/2.png
// module id = bBEt
// module chunks = 3